import { BrandInfoVO } from '@/api/dock'
import { PaginationOption } from '@/global'

interface State {
  formData: any
  dataSource: BrandInfoVO[]
  isTableLoading: boolean
  paginationOption: PaginationOption
  isTicketRelationModalOpen: boolean
  searchParams: any
  selectedRowKeys: string[]
  selectedRows: BrandInfoVO[]
  operateDataSource: BrandInfoVO[]
  selectedRowKeysForm: string[]
  selectedRowsForm: BrandInfoVO[]
}
type ActionType = CustomActionTypes<State>

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  formData: {},
  dataSource: [],
  isTableLoading: false,
  paginationOption: {
    pageNo: 1,
    pageSize: 20,
    totalCount: 0,
  },
  isTicketRelationModalOpen: false,
  searchParams: {},
  selectedRowKeys: [],
  selectedRowKeysForm: [],
  selectedRowsForm: [],
  selectedRows: [],
  operateDataSource: [],
}

export function reducer(state: State = initialState, action: Action): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoadingAction':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setPaginationOptionAction':
      newstate.paginationOption = action.payload
      return newstate
    case 'setIsTicketRelationModalOpenAction':
      newstate.isTicketRelationModalOpen = action.payload
      return newstate
    case 'setSelectedRowKeysAction':
      newstate.selectedRowKeys = action.payload
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    case 'setSearchParamsAction':
      newstate.searchParams = action.payload
      return newstate
    case 'setOperateDataSourceAction':
      newstate.operateDataSource = action.payload
      return newstate
    case 'setSelectedRowKeysFormAction':
      newstate.selectedRowKeysForm = action.payload
      return newstate
    case 'setSelectedRowsFormAction':
      newstate.selectedRowsForm = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    default:
      throw new Error('no match actions')
  }
}

/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

export const setDataSourceAction = (val: any): Action => ({
  type: 'setDataSourceAction',
  payload: val,
})

export const setSelectedRowKeysFormAction = (val: any): Action => ({
  type: 'setSelectedRowKeysFormAction',
  payload: val,
})

export const setSelectedRowsFormAction = (val: any): Action => ({
  type: 'setSelectedRowsFormAction',
  payload: val,
})

export const setOperateDataSourceAction = (val: any): Action => ({
  type: 'setOperateDataSourceAction',
  payload: val,
})

export const setPaginationOptionAction = (val: PaginationOption): Action => ({
  type: 'setPaginationOptionAction',
  payload: val,
})

export const setIsTableLoadingAction = (val: any): Action => ({
  type: 'setIsTableLoadingAction',
  payload: val,
})

export const setIsTicketRelationModalOpenAction = (val: any): Action => ({
  type: 'setIsTicketRelationModalOpenAction',
  payload: val,
})

export const setSelectedRowKeysAction = (val: any): Action => ({
  type: 'setSelectedRowKeysAction',
  payload: val,
})

export const setSelectedRowsAction = (val: any): Action => ({
  type: 'setSelectedRowsAction',
  payload: val,
})

export const setSearchParamsAction = (val: any): Action => ({
  type: 'setSearchParamsAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})
import { BrandInfoVO } from '@/api/dock'
import { PaginationOption } from '@/global'

interface State {
  formData: any
  dataSource: BrandInfoVO[]
  isTableLoading: boolean
  paginationOption: PaginationOption
  isTicketRelationModalOpen: boolean
  searchParams: any
  selectedRowKeys: string[]
  selectedRows: BrandInfoVO[]
  operateDataSource: BrandInfoVO[]
  selectedRowKeysForm: string[]
  selectedRowsForm: BrandInfoVO[]
}
type ActionType = CustomActionTypes<State>

interface Action {
  type: ActionType
  payload: any
}

export const initialState: State = {
  formData: {},
  dataSource: [],
  isTableLoading: false,
  paginationOption: {
    pageNo: 1,
    pageSize: 20,
    totalCount: 0,
  },
  isTicketRelationModalOpen: false,
  searchParams: {},
  selectedRowKeys: [],
  selectedRowKeysForm: [],
  selectedRowsForm: [],
  selectedRows: [],
  operateDataSource: [],
}

export function reducer(state: State = initialState, action: Action): State {
  const newstate = { ...state }
  switch (action.type) {
    case 'setFormDataAction':
      newstate.formData = action.payload
      return newstate
    case 'setDataSourceAction':
      newstate.dataSource = action.payload
      return newstate
    case 'setIsTableLoadingAction':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setPaginationOptionAction':
      newstate.paginationOption = action.payload
      return newstate
    case 'setIsTicketRelationModalOpenAction':
      newstate.isTicketRelationModalOpen = action.payload
      return newstate
    case 'setSelectedRowKeysAction':
      newstate.selectedRowKeys = action.payload
      return newstate
    case 'setSelectedRowsAction':
      newstate.selectedRows = action.payload
      return newstate
    case 'setSearchParamsAction':
      newstate.searchParams = action.payload
      return newstate
    case 'setOperateDataSourceAction':
      newstate.operateDataSource = action.payload
      return newstate
    case 'setSelectedRowKeysFormAction':
      newstate.selectedRowKeysForm = action.payload
      return newstate
    case 'setSelectedRowsFormAction':
      newstate.selectedRowsForm = action.payload
      return newstate
    case 'resetStateAction':
      return initialState
    default:
      throw new Error('no match actions')
  }
}

/**
 * 保存表单数据
 * @param val
 * @returns
 */
export const setFormDataAction = (val: any): Action => ({
  type: 'setFormDataAction',
  payload: val,
})

export const setDataSourceAction = (val: any): Action => ({
  type: 'setDataSourceAction',
  payload: val,
})

export const setSelectedRowKeysFormAction = (val: any): Action => ({
  type: 'setSelectedRowKeysFormAction',
  payload: val,
})

export const setSelectedRowsFormAction = (val: any): Action => ({
  type: 'setSelectedRowsFormAction',
  payload: val,
})

export const setOperateDataSourceAction = (val: any): Action => ({
  type: 'setOperateDataSourceAction',
  payload: val,
})

export const setPaginationOptionAction = (val: PaginationOption): Action => ({
  type: 'setPaginationOptionAction',
  payload: val,
})

export const setIsTableLoadingAction = (val: any): Action => ({
  type: 'setIsTableLoadingAction',
  payload: val,
})

export const setIsTicketRelationModalOpenAction = (val: any): Action => ({
  type: 'setIsTicketRelationModalOpenAction',
  payload: val,
})

export const setSelectedRowKeysAction = (val: any): Action => ({
  type: 'setSelectedRowKeysAction',
  payload: val,
})

export const setSelectedRowsAction = (val: any): Action => ({
  type: 'setSelectedRowsAction',
  payload: val,
})

export const setSearchParamsAction = (val: any): Action => ({
  type: 'setSearchParamsAction',
  payload: val,
})

/**
 * 重置redux内容，关闭页面时调用
 * @returns
 */
export const resetStateAction = (): Action => ({
  type: 'resetStateAction',
  payload: undefined,
})
